import { xyFilterX } from 'ml-spectra-processing';
/**
 * Get spectrum data with optional filtering and scaling
 * @param spectrum - The spectrum object containing x and y arrays
 * @param options - Configuration options
 * @returns Data object with filtered/scaled x and y arrays
 */
export function getData(spectrum, options = {}) {
    const { xFilter = {}, yFactor = 1 } = options;
    let data = { x: spectrum.x, y: spectrum.y };
    if (xFilter) {
        data = xyFilterX(spectrum, xFilter);
    }
    if (yFactor && yFactor !== 1) {
        data.y = data.y.map((y) => y * yFactor);
    }
    return data;
}
//# sourceMappingURL=getData.js.map